import styled from 'styled-components';
import {Button, Form, Modal, Table, Tag, Input} from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import defaultAvatar from '../../../../assets/images/icons/user-avater.png';
import {useMutation, useQuery, useQueryClient} from 'react-query';
import {useMemo, useState} from 'react';
import {auditTeamApply, getMyTeamMembers, getTeamMembers} from "../../../../api/Team";

export const CardTitle = styled.div`
  position: relative;
  font-size: 24px;
  margin-top: 20px;
  font-weight: 600;
  padding-left: 14px;
  ::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 80%;
    width: 5px;
    background-color: #40a9ff;
  }
`;

const AuthorAvatar = styled.img`
  display: inline-block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #fff;
  margin-left: 20px;
  margin-right: 20px;
`;

const Text = styled.span`
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  color: #FFFFFF;
`

const CustomModal = styled(Modal)`
  .ant-btn-primary {
    background-color: #6ee6c6;
    color: #000;
    border-color: #6ee6c6;
  }
  .ant-btn-default {
    &:hover {
      border-color: #6ee6c6;
      color: #6ee6c6;
    }
  }
`

const CustomInputTextarea = styled(Input.TextArea)`
    height: 120px !important;
    line-height: 30px !important;
    border-radius:4px !important;
    &:hover{
        border-color: #6ee6c6 !important;
    };
    &:focus-within{
        border-color: #6ee6c6 !important;
    }
`

const CustomTable = styled(Table)`
  .ant-btn-primary {
    color: #000;
  }
  .ant-table-thead tr th.ant-table-cell .ant-table-filter-column {
    color: #00eec2;
    .anticon {
      color: #00eec2;
    }
  }
  .ant-tag {
    font-weight: bold;
  }
`

const Author = styled.div`
  display: flex;
  align-items: center;
  > a > span {
    display: inline-block;
    max-width: 150px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`

export const MemberTable = ({type, title}) => {
    const { t } = useTranslation();
    const [page, setPage] = useState(1)
    const [filters, setFilters] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [auditItem, setAuditItem] = useState()
    const queryClient = useQueryClient()

    const {data, isLoading} = useQuery(['team-members', page, filters], () => {
        if (type === 0) {
            return getTeamMembers(title)
        }
        return getMyTeamMembers(filters.length ? filters[0] : undefined)
    })

    const auditMutation = useMutation('audit', ({id, type}) => auditTeamApply(id, type))

    const tableData = useMemo(() => data?.data?.list.map((item, index) => ({
        ...item,
        index
    })) ?? [], [data])

    const pageOptions = useMemo(() => {
        const {
            total = 0
        } = data?.data ?? {}
        return {
            total: total,
            perSize: 10,
        }
    }, [data])

    const pagination = useMemo(() => ({
        showSizeChanger: false,
        showQuickJumper: false,
        total: pageOptions.total,
        current: page,
        pageSize: pageOptions.perSize,
        onChange: (page) => {
            setPage(page);
        },
    }), [setPage, page, pageOptions])

    const handleOk = async () => {
        console.log(auditItem)
        await auditMutation.mutateAsync({
            id: auditItem.user.security_member.user_id,
            type: 1
        })
        setIsModalOpen(false)
        queryClient.invalidateQueries(['team-members', page, filters]).then()
    }

    const handleCancel = async () => {
        await auditMutation.mutateAsync({
            id: auditItem.user.security_member.user_id,
            type: 2
        })
        setIsModalOpen(false)
        queryClient.invalidateQueries(['team-members', page, filters]).then()
    }

    const onAudit = (item) => {
        setAuditItem(item)
        setIsModalOpen(true)
    }

    const columns = useMemo(() => {
        const defaultColumns = [
            {
                title: (t('AuthorTable.title')),
                dataIndex: 'name',
                key: 'name',
                render: (_, { index, user }) => (
                    <Author>
                        <AuthorAvatar src={user.avatar ? user.avatar : defaultAvatar} />
                        <Link to={`/whiteHats/${user.name}`}>
                            <Text>{user.name}</Text>
                        </Link>
                    </Author>
                ),
                width: 200,
                align: 'center',
                className: 'common-table-lv author-table-authors',
            },
            {
                title: (t('AuthorTable.reportNumber')),
                dataIndex: 'reports_count',
                key: 'reports_count',
                width: 100,
                render: (_, { user }) => (
                    <Text>{user.reports_count}</Text>
                ),
                align: 'center',
                className: 'common-table-lv',
            },
            {
                title: (t('AuthorTable.totalPoints')),
                dataIndex: 'total_points',
                key: 'total_points',
                width: 200,
                render: (_, { total_points }) => (
                    <Text>{total_points.toLocaleString(navigator.language)}</Text>
                ),
                align: 'center',
                className: 'common-table-lv',
            },
            {
                title: (`${t('AuthorTable.rewards')}  (USDC)`),
                dataIndex: 'rewards',
                key: 'rewards',
                width: 200,
                align: 'center',
                render: (_,{ rewards }) => (
                    <Text>{rewards.toLocaleString(navigator.language)}</Text>
                ),
                className: 'common-table-cell-date',
            },
        ]
        if (type === 1) {
            defaultColumns.push(
                {
                    title: 'Status',
                    align: 'center',
                    key: 'status',
                    width: 100,
                    filters: [{
                        text: 'Pending',
                        value: 0,
                    }, {
                        text: 'Confirmed',
                        value: 1,
                    }, {
                        text: 'Rejected',
                        value: 2,
                    }],
                    filterMultiple: false,
                    render: (_, row) => {
                        switch (row.user.security_member.status) {
                            case 0:
                                return <Tag>Pending</Tag>
                            case 1:
                                return <Tag color='#87d068'>Confirmed</Tag>
                            case 2:
                                return <Tag color='#f50'>Rejected</Tag>
                            default:
                                return null
                        }
                    }
                },
                {
                    title: 'Action',
                    align: 'center',
                    width: 200,
                    render: (_, row) => row.user.security_member.status === 0 ? (
                        <Button type='primary' onClick={() => onAudit(row)}>Audit</Button>
                    ) : null
                }
            )
        }
        return defaultColumns
    }, [type])

    const handleChange = (_, filters) => {
        setFilters(filters.status ?? [])
    }

    return (
        <>
            <CustomTable
                columns={columns}
                dataSource={tableData}
                pagination={(pagination)}
                loading={isLoading}
                className='author-table'
                rowKey='index'
                onChange={handleChange}
                scroll={{
                    x: '100%',
                }}
            />

            <CustomModal
                title="Apply Audit"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={[
                    <Button loading={auditMutation.isLoading} key='Reject' onClick={handleCancel}>
                        Reject
                    </Button>,
                    <Button loading={auditMutation.isLoading} type='primary' key="Approve" onClick={handleOk}>
                        Approve
                    </Button>
                ]}>
                <Form>
                    <Form.Item label=''>
                        <CustomInputTextarea placeholder='(optional)' value={auditItem?.user?.security_member?.apply_comment} />
                    </Form.Item>
                </Form>
            </CustomModal>
        </>
    );
};
